import { render, staticRenderFns } from "./Mobib.vue?vue&type=template&id=700a59d8&"
import script from "./Mobib.vue?vue&type=script&lang=js&"
export * from "./Mobib.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports